export default "__VITE_ASSET__D862HChf__"